module.exports = __webpack_public_path__ + "static/media/logo-we-write-code.cb9eedd8.svg";